import React,{createContext,useContext,useReducer} from "react";


const Context=createContext();

export function AppContext(props){
    const {children}=props;
    const [context,setContext]=useReducer((s,a)=>{
        if("theme" in a) setAppTheme(a.theme);
        return {...s,...a};
    },{
        theme:(it=>{
            if(it===null||it==="light") return it;
            else return "dark";
        })(localStorage.getItem("theme")),
    });
    return (
        <Context.Provider value={[context,setContext]}>
            {children}
        </Context.Provider>
    )
}

export const useAppContext=()=>useContext(Context);

let themeMedia;
const setAppTheme=(theme)=>{
    themeMedia?.removeEventListener("change",setAppTheme);
    let isLight;
    if(theme){
        themeMedia=null;
        isLight=theme==="light";
    }
    else{
        themeMedia=window.matchMedia("(prefers-color-scheme:light)");
        isLight=themeMedia.matches;
        themeMedia.addEventListener("change",()=>{setAppTheme()});
    }
    window.hasLightTheme=isLight;
    theme=isLight?"light":"dark";
    localStorage.setItem("theme",theme);
    document.documentElement.setAttribute("theme",theme);
    globalizeCssVars();
}

const globalizeCssVars=()=>{
    const {innerWidth}=window;
    window.rem=innerWidth/(innerWidth>567?300:100);
    const style=getComputedStyle(document.documentElement);
    [
        "mainFont","majorFont","minorFont",
        "mainColor","majorColor","minorColor",
        "accentColor","textColor","backgroundColor",
    ].forEach(name=>{
        window[name]=style.getPropertyValue(`--${name}`);
    });
};

const themeItem=localStorage.getItem("theme");
if(themeItem===null) setAppTheme();
else setAppTheme(themeItem);
